import { AREA_AVERAGES } from "../configurations/Urls";
import Session from "../helpers/SessionHelper";
import axios from "axios";

const AreaService = {
  async getAreaAverageGraph(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(`${AREA_AVERAGES}${payload}`, {
      headers: headers,
    });
    return response;
  },
};
export default AreaService;
